/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import FlyDragDropManagerService from 'fly-drag-drop/services/fly-drag-drop-manager';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class SortableHandle extends Component {
  @service flyDragDropManager!: FlyDragDropManagerService;

  dotsImage = new URL('cio/assets/images/drag-drop/dots.svg', import.meta.url).toString();
}
